<template>
  <div class="bg-agentnoon-primary-700 hidden min-h-screen w-screen md:block lg:block">
    <LogoAsset class="absolute m-4" />
    <div class="flex min-h-screen flex-col items-center justify-center">
      <div class="max-w-xl">
        <h1 class="text-center text-3xl text-white">
          {{ heroHeadline }}
        </h1>
        <div class="flex flex-col items-center justify-center">
          <div class="mt-5 flex flex-row">
            <StarIcon class="mx-1" />
            <StarIcon class="mx-1" />
            <StarIcon class="mx-1" />
            <StarIcon class="mx-1" />
            <StarIcon class="mx-1" />
          </div>
        </div>
      </div>
      <p class="text-primary-200 absolute bottom-5 left-5">
        &copy; {{ footerBrand }} {{ new Date().getFullYear() }}
        <span v-if="versions.frontend && showVersionInfo">
          • FE: {{ versions.frontend?.pr_num || versions.frontend?.tag || 'N/A' }}
        </span>
        <span v-if="versions.backend && showVersionInfo">
          • BE: {{ versions.backend?.version || 'N/A' }}
        </span>
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import LogoAsset from '@/assets/Logo/Agentnoon-Logo-Blue-White-Text.svg'
import StarIcon from '@/assets/SvgIcons/Star-5.svg'
import { fetchVersions } from '@/services/version-api.service.js'
import { useEmbedMode } from '@/hooks/use-embed-mode'
import { logger } from '@/utils/logger'

const mode = import.meta.env.MODE
const showVersionInfo = computed(() => mode !== 'production')

const versions = ref({
  backend: null,
  frontend: null
})
const { isEmbedded } = useEmbedMode()
const heroHeadline = computed(() =>
  isEmbedded.value
    ? 'Welcome to Dayforce SWP. Your control panel for collaborative workforce planning.'
    : 'Welcome to Agentnoon. Your control panel for collaborative workforce planning.'
)
const footerBrand = computed(() => (isEmbedded.value ? 'Dayforce SWP' : 'Agentnoon'))

const loadVersions = async () => {
  try {
    versions.value = await fetchVersions()
  } catch (error) {
    logger.error('Error loading versions:', error.message)
  }
}

onMounted(() => {
  if (showVersionInfo.value) {
    loadVersions()
  }
})
</script>
